import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { AccessContext } from 'context';
import { CircularProgress } from '@mui/material';

const AccessProvider = ({ children }) => {
  const [accesses, setAccesses] = useState([]);
  const axiosPrivate = useAxiosPrivate();

  const { isLoading, isFetching } = useQuery({
    queryKey: '/dictionary/userobjects',
    queryFn: async function () {
      const response = await axiosPrivate.get('/dictionary/userobjects');
      return response?.data?.data || [];
    },
    onSuccess: (data) => {
      if (data && data.length > 0) {
        setAccesses(data.map((item) => item?.object_id?.toString()));
      }
    },
    enabled: true,
    retry: false,
  });

  const hasAccess = useCallback(
    (value) => {
      return accesses?.length > 0
        ? accesses?.includes(value?.toString())
        : false;
    },
    [accesses]
  );

  return isLoading || isFetching ? (
    <div className='h-screen flex flex-col items-center justify-center text-lg'>
      <CircularProgress size={40} color='success' />
    </div>
  ) : (
    <AccessContext.Provider value={{ accesses, hasAccess }}>
      {children}
    </AccessContext.Provider>
  );
};

export default AccessProvider;
